import { Yii } from "libraries/interfaces/Yii";

export interface IDialogLabels {
    title: string;
    question: string;
    cancel: string;
    accept: string;
}

export const DIALOG_QUALITY_CHECK_WORDING: IDialogLabels = {
    title: Yii.t('wui-shared-js', 'Vérification du dossier'),
    question: Yii.t('wui-shared-js', 'Voulez-vous vérifier le dossier ?'),
    cancel: Yii.t('wui-shared-js', 'Abandonner'),
    accept: Yii.t('wui-shared-js', 'Vérifier le dossier sélectionné'),
};

export const DIALOG_CANCEL_WORDING: IDialogLabels = {
    title: Yii.t('wui-shared-js', 'Annulation du dossier'),
    question: Yii.t('wui-shared-js', 'Voulez-vous annuler le dossier ?'),
    cancel: Yii.t('wui-shared-js', 'Abandonner'),
    accept: Yii.t('wui-shared-js', 'Annuler le dossier sélectionné'),
};

export const DIALOG_ISSUE_WORDING: IDialogLabels = {
    title: Yii.t('wui-shared-js', 'Émission du dossier'),
    question: Yii.t('wui-shared-js', 'Voulez-vous émettre le dossier ?'),
    cancel: Yii.t('wui-shared-js', 'Abandonner'),
    accept: Yii.t('wui-shared-js', 'Émettre le dossier sélectionné'),
};

export const DIALOG_VOID_WORDING: IDialogLabels = {
    title: Yii.t('wui-sasha-js', 'Void du dossier'),
    question: Yii.t('wui-sasha-js', 'Voulez-vous voider le dossier ?'),
    cancel: Yii.t('wui-sasha-js', 'Abandonner'),
    accept: Yii.t('wui-sasha-js', 'Voider le dossier sélectionné'),
};

export const DIALOG_UPDATE_WORDING: IDialogLabels = {
    title: Yii.t('wui-sasha-js', 'Mise à jour du dossier'),
    question: Yii.t('wui-sasha-js', 'Voulez-vous mettre à jour le dossier ?'),
    cancel: Yii.t('wui-sasha-js', 'Abandonner'),
    accept: Yii.t('wui-sasha-js', 'Mettre à jour le dossier sélectionné'),
};

export const DIALOG_VOUCHER_WORDING: IDialogLabels = {
    title: Yii.t('wui-sasha-js', 'Voucher'),
    question: Yii.t('wui-sasha-js', 'Voulez-vous obtenir le voucher du dossier ?'),
    cancel: Yii.t('wui-sasha-js', 'Abandonner'),
    accept: Yii.t('wui-sasha-js', 'Obtenir le voucher'),
};
